import React from "react";
import { Card, CardBody } from "reactstrap";

export default function StateDisplay(props) {
  const { state } = props;

  if (process.env.NODE_ENV === "development") {
    return (
      <Card className="mt-3">
        <CardBody>
          <h5>Model JSON</h5>
          <pre>{JSON.stringify(state, null, 4)}</pre>
        </CardBody>
      </Card>
    );
  }

  return null;
}



// WEBPACK FOOTER //
// ./src/Shared/DisplayState.js